let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jIVVt")).then(() => parcelRequire('6Yupz'));